var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 152,
    viewBox: "0 0 166 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8639 1.88558C93.7064 -2.29867 113.327 0.982039 129.333 10.6142C145.15 20.1328 154.419 35.8119 159.629 52.8967C165.32 71.5548 168.68 91.58 159.443 109.345C149.203 129.039 131.415 147.374 108.618 151.003C86.605 154.507 69.3558 137.485 50.6587 126.662C31.7969 115.744 5.86946 109.29 1.11591 88.7773C-3.64412 68.2367 14.7156 49.6605 28.9327 32.9094C41.1684 18.493 55.9405 6.08777 74.8639 1.88558Z",
    fill: "url(#paint0_linear_82_311)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_311",
    x1: 65.489,
    y1: 4.00709,
    x2: 99.2671,
    y2: 153.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC6BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankVector);
export default __webpack_public_path__ + "static/media/Bank_Vector.86e288245b48f5ac7902db6a173e4068.svg";
export { ForwardRef as ReactComponent };